import React, { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "store/useAuthStore";
import { routeVariables } from "./routeVariables";
import { checkPermission } from "utils/checkPermissions";

interface ProtectedRouteProps {
  element: ReactElement;
  permissions?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, permissions }) => {
  const { isAuthenticated, profile } = useAuthStore();
  const hasAllPermissions = true;

  if (!isAuthenticated) {
    return <Navigate to={routeVariables.login} />;
  }
  // if (profile?.role?.isSuperAdmin) {
  if (hasAllPermissions) {
    return element;
  }
  if (permissions && profile) {
    const hasPermission = checkPermission(profile, permissions);
    if (!hasPermission) {
      return <Navigate to={routeVariables.main} />;
    }
  }

  return element;
};

export default ProtectedRoute;
